import axios from "../../axios";

const getWigOrders = async (customer_id, appointment_id) => {
  let query = '';
  if (appointment_id) {
    query = `&appointment_id[$eq]=${appointment_id}`;
  }
  if (customer_id) {
    query += `&customer_id[$eq]=${customer_id}`;
  }

  query = query.charAt(0) === '&' ? `?${query.slice(1)}` : query;
  
  try {
    const { data } = await axios.get(`/wig_orders${query}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const getWigsToAssign = async (inventory_item_id) => {
  try {
    const { data } = await axios.get(`/inventory/inventory_item/${inventory_item_id}`);
    return data?.rows;
  } catch (e) {
    return null;
  }
};

const assignWig = async ({wig_order_id, info}) => {
  try {
    const { data } = await axios.put(`/wig_orders/assign/${wig_order_id}`, { ...info });
  } catch (e) {
    throw e;
  }
}

const unlinkWig = async ({wig_order_id, info}) => {
  try {
    const { data } = await axios.put(`/wig_orders/unlink/${wig_order_id}`, { ...info });
  } catch (e) {
    throw e;
  }
}


export { 
  getWigOrders,
  getWigsToAssign,
  assignWig,
  unlinkWig 
};